import React from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import Icons from "../../../../Components/Icons/Icons";
import Modal from "react-bootstrap/Modal";
import Inputs from '../../../../Components/Inputs/Inputs';
import {getUserInfo} from '../../../../Utils/UserFunctions';

const folderPopup = (props) => {
    //console.log(JSON.parse(props.formFolderFields), 'props.formFolderFields');
    //console.log(getUserInfo(), 'getUserInfo')
    const curProfileID = getUserInfo().data.profile_id;
    const fieldDetail = JSON.parse(props.formFolderFields);
    const profileList = JSON.parse(props.profileList);
    let activeProfiles = "";
    activeProfiles = profileList.map((profile,index) => {
      let checkedVal = true;
      if(curProfileID===profile.profile_id){
        return false;
      }
      if(fieldDetail.profile_ids.indexOf(profile.profile_id) === -1){
        checkedVal = false;
      }

      return(
          <div className="selectgroup selectgroup-pills" key={index}>
              <Wrp key={index}>
                  <label key={index} className="selectgroup-item mb-1">
                      <input type="radio" name={"profile"+profile.profile_id} value={profile.profile_id} className="selectgroup-input" checked={checkedVal} />
                      <span className="selectgroup-button" onClick={e=>props.addOrDeleteProfileHandler(profile.profile_id)}> {profile.profile_name} </span>                                        
                  </label>
              </Wrp>
          </div>
          // <span key={index}>{profile.profile_name}</span>
      )
  });


    return(
        <Wrp>
            <Modal dialogClassName="modal-dialog modal-dialog modal-md height-auto" show={props.modalFolderPopup} onHide={props.toggleFolderPopup}>
              <Modal.Header>
                {
                  (fieldDetail.mode === 'add')? 
                  <h5 className="modal-title secondary_color pl-2 mb-0"> Create New Folder </h5> 
                  :
                  <h5 className="modal-title secondary_color pl-2 mb-0">Update Folder </h5>
                  
                }                                
              </Modal.Header>
              <Modal.Body>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label><b> Folder Name </b></label>                                            
                        <Inputs fieldName="folder_name" formData={JSON.stringify(fieldDetail.folder_name)} changed={props.addDataHandlerFolder}/> 
                        {fieldDetail.folder_name.error !== "" ? 
                            <label className="error m-0">{fieldDetail.folder_name.error}</label>
                            : null
                        }
                      </div>
                    </div>


                    <div className="col-12">
                      <div className="form-group">
                        <h6> Share With Others </h6>
                        {activeProfiles}
                      </div>
                    </div>  
                  </div>

              </Modal.Body>

              <Modal.Footer>
                  <a href="#" className="btn btn-cancel mr-2" data-dismiss="modal" onClick={props.toggleFolderPopup}> Cancel </a> 
                  {
                    (fieldDetail.mode === 'add')?
                    <a href="#" className="btn primary_bg" onClick={props.addFolderHandler}>Add</a>
                    :
                    <a href="#" className="btn primary_bg" onClick={props.addFolderHandler}>Save</a>
                  }
                                  
              </Modal.Footer>
            </Modal>

            
        </Wrp>
    )
}

export default folderPopup;